export default __webpack_public_path__ + "bfc6d13758d8c431e34677477a8e2a39.svg";